import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { OBEDIENCE_OPTIONS } from './constants';

export const ScreenObedience: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Obedience',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const obedience = form.watch('obedience');

  const handleChange = (option: OnbOptionType<LayoutDataType['obedience']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        obedience: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>
          Should she challenge your ideas or agree with you more often?
        </OwnAiTitle>
        <OnboardingOptionsList>
          {OBEDIENCE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={obedience === option.id}
              control={form.control}
              option={option}
              name="obedience"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`obedience-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
